module.exports = __webpack_public_path__ + "img/header-center.a466c424.png";